import * as React from "react";
type Props = {
  className?: string,
};
function SvgWallet({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Wallet"
      className={className}
    >
      <rect
        x={3}
        y={5}
        width={18}
        height={15}
        rx={2}
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M7.882 11H3v-1a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1h-4.882c-.685 0-1.312.387-1.618 1-.306.613-.933 1-1.618 1h-1.764A1.809 1.809 0 0 1 9.5 12c-.306-.613-.933-1-1.618-1Z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
export default SvgWallet;
